/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CompanySuggestionResource } from './';
import {
    CompanySuggestionResourceFromJSON,
    CompanySuggestionResourceFromJSONTyped,
    CompanySuggestionResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface CompanySuggestionsResource
 */
export interface CompanySuggestionsResource {
    /**
     * 
     * @type {Array<CompanySuggestionResource>}
     * @memberof CompanySuggestionsResource
     */
    suggestions: Array<CompanySuggestionResource>;
}

/**
 * Check if a given object implements the CompanySuggestionsResource interface.
 */
export function instanceOfCompanySuggestionsResource(value: object): value is CompanySuggestionsResource {
    if (!('suggestions' in value) || value['suggestions'] === undefined) return false;
    return true;
}

export function CompanySuggestionsResourceFromJSON(json: any): CompanySuggestionsResource {
    return CompanySuggestionsResourceFromJSONTyped(json, false);
}

export function CompanySuggestionsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanySuggestionsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestions': ((json['suggestions'] as Array<any>).map(CompanySuggestionResourceFromJSON)),
    };
}

export function CompanySuggestionsResourceToJSON(value?: CompanySuggestionsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'suggestions': ((value['suggestions'] as Array<any>).map((v) => CompanySuggestionResourceToJSON(v))),
    };
}

